'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _webResults = require('./components/web-results');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_webResults).default;
  }
});

var _itemAnnotationInput = require('./components/item-annotation-input');

Object.defineProperty(exports, 'ItemAnnotationInput', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_itemAnnotationInput).default;
  }
});

var _urlInput = require('./components/url-input');

Object.defineProperty(exports, 'URLInput', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_urlInput).default;
  }
});

var _webItemTitleInput = require('./components/web-item-title-input');

Object.defineProperty(exports, 'WebItemTitleInput', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_webItemTitleInput).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/add-title/lib/components/web-results/index.js
// module id = 988
// module chunks = 1